import { ExerciseSummary, ExerciseType } from '../types';

export enum ExerciseTypeLabel {
  Individual = 'Individual',
  Team = 'Team',
}

// TODO remove this helper when we have final decision what will be the name for Exercise type, we need to fix also API responses + component names.
export const reLabelExerciseType = (type: ExerciseType) => {
  return type === ExerciseType.Classroom ? ExerciseTypeLabel.Team : ExerciseTypeLabel.Individual;
};

export const isAdHoc = (exercise: Partial<ExerciseSummary>): boolean => !!exercise?.adHoc;
